import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable, Subscriber } from 'rxjs';
import 'rxjs/add/operator/map';
import { HttpClientService } from './../http-client/http-client.service';
import { Student } from '../../models/students/student';
import { AddStudentDto } from '../../models/students/dto/AddStudentDto';
import { ChangeCourseStudentDto } from '../../models/students/dto/ChangeCourseStudentDto';
import { AddEditPaymentDto } from '../../models/students/dto/AddEditPaymentDto';
import { HistoryStudent } from '../../models/students/dto/HistoryStudentDto';

@Injectable()
export class StudentService {

    public students: Student[];
    public historyStudent: HistoryStudent[];
    public studentObject: any;
    public historyStudentObject: any;

    constructor(
        private http: HttpClientService
    ) {
        this.students = [];
        this.studentObject = {};
    }

    public getAllByShift(schoolYearId,userId): Observable<Student[]> {
        if (!!this.students && this.students.length > 0) {
            return Observable.create((observer: Subscriber<Student[]>) => {
                observer.next(this.students);
                observer.complete();
            });
        }
        
        const url = 'students/allbyshift/' + schoolYearId + '/' + userId;
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.students = r.Result;
                //console.log(this.students);
                this.studentObject = this.students.reduce((result, s) => {
                    result[String(s.Id)] = result[String(s.Id)] || {};
                    result[String(s.Id)] = s;
                    return result;
                }, {});
            } else {
                console.error('StudentService > getAll > response', r);
            }
            return this.students;
        }).catch(this.handleError);
    }

    public getById(Id: string,  schoolYearId ): Observable<Student> {
        /*if (!!this.students && this.students.length > 0 && !!this.students.find(s => s.Id == Id)) {
            return Observable.create((observer: Subscriber<Student>) => {
                observer.next(this.students.find(s => s.Id == Id));
                observer.complete();
            });
        }*/
        const url = 'students/id/' + Id  + "/" + schoolYearId;
        return this.http.get(url).map(response => {
            let r = response.json();
            let student = null;
            console.log('resultcodeGETSTUDENT ', r);
            if (r.ResultCode === 1) {
                student = r.Result;
                let alreadyExist = this.students.find(s => s.Id == student.Id);
                if (!alreadyExist) {
                    this.students.push(student);
                    this.studentObject[student.id] = student;
                }
            } else {
                console.error('StudentService > getById > response***********', r);
            }
            return student;
        }).catch(this.handleError);
    }

    public getHistoryByStudent(docNumber): Observable<Student[]> {
        
        const url = 'students/historyst/' + docNumber;
        return this.http.get(url).map(response => {
            let r = response.json();
            if (r.ResultCode === 1) {
                this.historyStudent = r.Result;
                //console.log(this.students);
                this.historyStudentObject = this.historyStudent.reduce((result, s) => {
                    result[String(s.SchoolYear)] = result[String(s.SchoolYear)] || {};
                    result[String(s.SchoolYear)] = s;
                    return result;
                }, {});
            } else {
                console.error('StudentService > historyst > response', r);
            }
            return this.historyStudent;
        }).catch(this.handleError);
    }

    public add(addStudentDto: AddStudentDto) {
        const url = 'students/add';
        console.log("****************************************************");
        return this.http.post(url, addStudentDto).map(response => response.json())
        .catch(this.handleError);
    }

    public edit(addStudentDto: AddStudentDto) {
        const url = 'students/add';
        return this.http.post(url, addStudentDto).map(response => response.json())
        .catch(this.handleError);
    }

    public addOrEditPayment(addStudentDto: AddEditPaymentDto) {
        const url = 'students/addpayment';
        console.log("****************************************************");
        return this.http.post(url, addStudentDto).map(response => response.json())
        .catch(this.handleError);
    }

    public changeCourse(changeCourseStudentDto: ChangeCourseStudentDto) {
        const url = 'students/changecourse';
        return this.http.post(url, changeCourseStudentDto).map(response => response.json())
        .catch(this.handleError);
    }

    public delete(id: string) {
        const url: string = 'students/delete/' + id;
        return this.http.delete(url).map(response => response.json())
            .catch(this.handleError);
    }

    public handleError(error: Response) {
        // console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

}



// WEBPACK FOOTER //
// ./src/app/main/services/students/student.service.ts